import React, { useState } from "react";
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import EditIcon from "@mui/icons-material/Edit";
import CancelIcon from '@mui/icons-material/Cancel';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import InputAdornment from '@mui/material/InputAdornment';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { update_project } from "../../../../services/project_service"; // à adapter selon ton service
import "./UpdateProject.css";


function UpdateProject({ project, directions, onClose, update_project_list }) {
  const [waiting, setWaiting] = useState(false);
  const [errorText, setErrorText] = useState("");

  const [formData, setFormData] = useState({
    title: project.title??"",
    direction: project.direction??"",
    project_manager: project.project_manager??"",
    start_date: project.start_date??"",
    end_date: project.end_date??"",
    estimated_budget: project.estimated_budget??"",
    description: project.description??"",
  });



  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleUpdate = async () => {
    setErrorText("");
    const { title, direction, project_manager, start_date, end_date } = formData;

    if (!title || !direction || !project_manager || !start_date || !end_date) {
      setErrorText("Veuillez remplir tous les champs obligatoires.");
      return;
    }

    setWaiting(true);
    try {
      const response = await update_project(project.project_code, formData); // ou project.id selon ton backend
     //  console.log("Projet modifié avec succès :", response.data);
      if (update_project_list) update_project_list(response.data.data,project.index); // pour recharger la liste
      onClose();
      setWaiting(false);
    } catch (error) {
      console.error(
        "Erreur lors de la modification du projet :",
        error.response?.data || error.message
      );
      setWaiting(false);
    }
  };

  return (
    <Dialog open onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Modifier le projet</DialogTitle>
      <DialogContent>
        <div className="inputs_container">
          <TextField
            label="Titre *"
            name="title"
            variant='standard'
            className="input_form"
            value={formData.title}
            onChange={handleChange}
          />
          <FormControl variant='standard' className="input_form">
            <InputLabel>Direction *</InputLabel>

            <Select value={formData.direction} name="direction" onChange={handleChange}>
              <MenuItem value="null" disabled>
                <em>None</em>
              </MenuItem>
              {
                directions.map((dir) => (
                  <MenuItem key={"dir" + dir.id} value={dir.id}>{dir.title}</MenuItem>
                ))
              }
            </Select>
          </FormControl>
          <TextField
            label="Chef du projet *"
            name="project_manager"
            variant='standard'
            className="input_form"
            value={formData.project_manager}
            onChange={handleChange}
          />
        </div>
        <div className="inputs_container">
          <TextField
            label="Budget estimatif (MAD) *"
            name="estimated_budget"
            variant='standard'
            className="input_form"
            value={formData.estimated_budget}
            onChange={handleChange}
          />
          <TextField
            label="Date de début *"
            name="start_date"
            type="date"
            variant='standard'
            className="input_form"
            value={formData.start_date}
            onChange={handleChange}
            slotProps={{
              input: { startAdornment: (<InputAdornment position="start"> <EventAvailableIcon className="my_icon" /> </InputAdornment>), }
            }}
          />
          <TextField
            label="Date de fin *"
            name="end_date"
            type="date"
            variant='standard'
            className="input_form"
            value={formData.end_date}
            onChange={handleChange}
            slotProps={{
              input: { startAdornment: (<InputAdornment position="start"> <EventAvailableIcon className="my_icon" /> </InputAdornment>), }
            }}
          />
        </div>
        <TextField
          margin="dense"
          label="Description"
          name="description"
          fullWidth
          multiline
          rows={4}
          value={formData.description}
          onChange={handleChange}
        />
      </DialogContent>
      <DialogActions>
        <div className='dialogBottom'>
          <div>
            {
              errorText==""
                ? <></>
                : <p className={errorText ? "col-md-10 error" : "col-md-10 valid-champ"}>
                  {errorText}
                </p>
            }
          </div>
          <div>
            <Button variant="contained" className="submit_but cancel_but" startIcon={<CancelIcon />} onClick={onClose} >
              Annuler
            </Button>
            <Button variant="contained" className="submit_but valide_but" startIcon={<EditIcon />} onClick={handleUpdate} >
              Modifier
            </Button>
          </div>
        </div>
      </DialogActions>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={waiting}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Dialog>
  );
}
export default UpdateProject;
